var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "tandem-filters-container" }, [
    _c("div", { staticClass: "buttons-row" }, [
      _c("span", { staticClass: "tandem-filters-title" }, [
        _vm._v(_vm._s(_vm.texts.textSearch)),
      ]),
      _c(
        "div",
        { staticClass: "buttons-container" },
        [
          _c("LfLabelButtonComponent", {
            staticClass: "clear-button",
            attrs: {
              text: _vm.texts.cleanFilter,
              action: () => _vm.clearFilters(),
              variant: _vm.variant.text,
            },
          }),
        ],
        1
      ),
    ]),
    _vm.showDescriptors
      ? _c("div", { staticClass: "tandem-aditional-filters" }, [
          _c("div", { staticClass: "tandem-aditional-filter-tbox" }, [
            _vm._v(_vm._s(_vm.texts.aditionalFilters)),
          ]),
          _c(
            "div",
            { staticClass: "tandem-descriptors-container" },
            _vm._l(_vm.getDescriptors, function (descriptor) {
              return _c("div", { staticClass: "tandem-descriptor" }, [
                _c("div", { staticClass: "tandem-descriptor-text" }, [
                  _vm._v(_vm._s(descriptor.value.value)),
                ]),
                _c("div", {
                  staticClass: "lf-icon-close-round tandem-descriptor-close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.removeDescriptor(descriptor.key)
                    },
                  },
                }),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "tandem-filters" }, [
      _c(
        "div",
        { staticClass: "row-1" },
        _vm._l(_vm.tandemFilters, function (filter, index) {
          return index <= 2
            ? _c(
                "div",
                { staticClass: "filter" },
                [
                  _c("LexonSelectComponent", {
                    ref: filter.label,
                    refInFor: true,
                    attrs: {
                      label: filter.label,
                      propItems: filter.items,
                      isMultiselect: filter.multiSelect,
                      renderChips: filter.multiSelect,
                      keyValue: filter.keyValue ? filter.keyValue : "",
                      returnObject: false,
                      paginated: false,
                      showAllChips: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setSelected($event, filter)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e()
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "row-2" },
        _vm._l(_vm.tandemFilters, function (filter, index) {
          return index > 2
            ? _c("div", { staticClass: "filter" }, [
                filter.type === _vm.filterTypes.List
                  ? _c(
                      "div",
                      [
                        _c("LexonSelectComponent", {
                          ref: filter.label,
                          refInFor: true,
                          attrs: {
                            label: filter.label,
                            propItems: filter.items,
                            isMultiselect: filter.multiSelect,
                            renderChips: filter.multiSelect,
                            keyValue: filter.keyValue ? filter.keyValue : "",
                            returnObject: false,
                            paginated: false,
                            showAllChips: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.setSelected($event, filter)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                filter.type === _vm.filterTypes.DateInterval
                  ? _c(
                      "div",
                      [
                        _c("LexonDateRangePickerComponent", {
                          ref: filter.label,
                          refInFor: true,
                          attrs: { tandemSearch: true, label: filter.label },
                          on: {
                            input: function ($event) {
                              return _vm.setSelected($event, filter)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                filter.type === _vm.filterTypes.Switch ? _c("div") : _vm._e(),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }